<p>auctiondetailsheader works!</p>
